import axios from 'axios';

// Centralized axios instance so every API call shares the same base URL and headers.
// This means we only configure things like the base URL or auth token ONCE here,
// instead of repeating it in every single API call across the app.
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// Automatically attach the JWT token (if it exists) to every outgoing request.
// This runs before every request is sent.
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});




axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axiosInstance;